import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List.MenuCategories';

@Injectable({
  providedIn: 'root'
})
export class MenuCategoryService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResMenuCategory/ResGetAllMenuCategory`, filter);
  }
  ResGetAllMenuCategoryList(restId: number): any {
    return this.http.get(`${environment.apiUrl}/ResMenuCategory/ResGetAllMenuCategoryList?RestaurantId=${restId}`);
  }
  GetDetails(id: string) {
    return this.http.get(`${environment.apiUrl}/ResMenuCategory/ResGetMenuCategoryById?id=${id}`);
  }
  GetAllMenuCategoryList(RestaurantId: number) {
    return this.http.get(`${environment.apiUrl}/ResMenuCategory/ResGetAllMenuCategoryList?RestaurantId=${RestaurantId}`);
  }
  delete(id: string) {
    return this.http.post(`${environment.apiUrl}/ResMenuCategory/ResDeleteMenuCategory?id=${id}`, null);
  }
  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/ResMenuCategory/ResEditMenuCategory`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/ResMenuCategory/ResNewMenuCategory`, data);
    }
  }
}
